/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IMenuConfigurationScope extends angular.IScope {
        model: models.MenuConfigurationModel;
    }

    export class MenuConfigurationController implements IController {
        scope: IMenuConfigurationScope;

        constructor(
            $scope: IMenuConfigurationScope,
            menuConfigurationService: warsApp.services.MenuItemService,
            menuLinkService: warsApp.services.MenuLinkService,
            contentPageService: warsApp.services.ContentPageService,
            securityMatrixService: warsApp.services.SecurityMatrixService,
            processTypeService: services.ProcessTypeService) {
            this.scope = $scope;
            this.scope.model = new warsApp.models.MenuConfigurationModel(menuConfigurationService, menuLinkService, contentPageService, securityMatrixService, processTypeService);
        }
    }
}

warsApp.registerController('MenuConfigurationController', ['$scope', 'menuItemService', 'menuLinkService', 'contentPageService', 'securityMatrixService', 'processTypeService']);